import { render, staticRenderFns } from "./CollapseIcon.vue?vue&type=template&id=4806cbff"
import script from "./CollapseIcon.vue?vue&type=script&lang=js"
export * from "./CollapseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports